export default {
    setFilters: (state, resp) => {
        console.log('setFilters', resp);
        state.filter = Object.assign({}, state.filter, resp);
    },
    setSubscriptionStatus: (state, status) => {
        state.subscriptionStatus = status;
    },
}